import { UnassignedItem } from 'src/entities/dispatch';

/**
 * 日付変更や再取得で未割当から消えた ID を選択 state から除去する。
 * 残すと「N件選択中」が実態とズレる（convenience は Presenter.tsx:2367-2383 で同じことをしている）。
 * /map には自動配車の復元待ち（pendingNotAllocSelect）が無いので pending ガードは持たない。
 */
export function pruneSelectedUnassignedIds(
  prev: ReadonlySet<string>,
  items: readonly UnassignedItem[],
): Set<string> {
  if (prev.size === 0) return prev as Set<string>;
  const validIds = new Set(items.map((item) => item.id));
  let changed = false;
  const next = new Set<string>();
  prev.forEach((id) => {
    if (validIds.has(id)) next.add(id);
    else changed = true;
  });
  return changed ? next : (prev as Set<string>);
}
